import Reports from './reports';
import reportTypeSelector from './reportTypeSelector';
import entityComposition from '../common/classes/entityComposition';
import { editPermissionSelector, viewPermissionSelector } from '../common/classes/permissions';
export default entityComposition(Reports, ['jobFilterAdd', 'report', 'reportTypeFilterAdd', 'displaySettings'], {
  dynamicReportTypes: state => ({
    list: reportTypeSelector.getDynamicReportTypes(state),
    loading: state.reportTypeFilterReport.loading
  }),
  user: state => state.login.user,
  canEdit: state => editPermissionSelector('report')(state),
  canView: state => viewPermissionSelector('report')(state),
  geolocation: state => state.login.geolocation,
  userType: state => state.login.user.permissions.userType,
  username: state => state.login.user.username
}, []);